@let isDeleteConfirm = data?.submitActionTranslateKey?.includes("delete");

<mat-dialog-content class="mat-typography">
  <h2>{{ data.headerTranslateKey | translate: data.headerParams }}</h2>
  @if (body) {
    <p [innerHTML]="body | highlight: data.bodyParams"></p>
  }

  @if (data.alertTranslateKey) {
    <div class="messages-container" [ngClass]="data.alertType">
      <div class="flex--r-c gap--8">
        @if (data.alertType === "warn") {
          <mat-icon>warning</mat-icon>
        } @else if (data.alertType === "info") {
          <mat-icon>info</mat-icon>
        }
        <span>{{ data.alertTranslateKey | translate }}</span>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (!data.isCancelHidden) {
    <button
      data-cy="cancel-btn"
      mat-stroked-button
      [mat-dialog-close]="data.reverseActions"
    >
      <mat-icon>close</mat-icon>
      {{ data.cancelActionTranslateKey ?? "app.cancel.label" | translate }}
    </button>
  }
  @if (data.secondarySubmit) {
    <button
      data-cy="extra-btn"
      mat-flat-button
      [color]="data.secondarySubmit?.color ?? 'primary'"
      [mat-dialog-close]="'secondarySubmit'"
    >
      @if (data.secondarySubmit?.icon) {
        <mat-icon>{{ data.secondarySubmit?.icon }}</mat-icon>
      }
      {{ data.secondarySubmit?.translateKey | translate }}
    </button>
  }
  <button
    data-cy="confirm-btn"
    mat-flat-button
    [color]="isDeleteConfirm ? 'warn' : 'accent'"
    [mat-dialog-close]="!data.reverseActions"
  >
    @if (isDeleteConfirm) {
      <mat-icon>delete_forever</mat-icon>
    } @else {
      <mat-icon>{{ data.submitIcon ?? "done" }}</mat-icon>
    }
    {{ data.submitActionTranslateKey ?? "app.okay.label" | translate }}
  </button>
</mat-dialog-actions>
